import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { deleteResponseCenter } from "../../core/api/responsecenters/responsecenters";

export const DeleteAlarmReceptionModal = ({
  isOpen,
  responseCenterId,
  onClose,
  onDelete,
}: {
  isOpen: boolean;
  responseCenterId?: number;
  onClose: () => void;
  onDelete?: () => void;
}) => {
  if (!responseCenterId) {
    return null;
  }

  return (
    <DeleteModal
      isOpen={isOpen}
      locizeKey="alarm_reception"
      callDelete={(authReq) => deleteResponseCenter(responseCenterId, authReq)}
      onClose={onClose}
      onDelete={onDelete}
    />
  );
};
